/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetReservationShifts200Response,
} from '../models/index';
import {
    GetReservationShifts200ResponseFromJSON,
    GetReservationShifts200ResponseToJSON,
} from '../models/index';

export interface UpsertReservationShiftsRequest {
    getReservationShifts200Response: GetReservationShifts200Response;
}

/**
 * 
 */
export class ShiftsApi extends runtime.BaseAPI {

    /**
     */
    async deleteReservationShiftsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/shifts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteReservationShifts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReservationShiftsRaw(initOverrides);
    }

    /**
     */
    async getReservationShiftsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationShifts200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/shifts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationShifts200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationShifts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationShifts200Response> {
        const response = await this.getReservationShiftsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertReservationShiftsRaw(requestParameters: UpsertReservationShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationShifts200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationShifts200Response',
                'Required parameter "getReservationShifts200Response" was null or undefined when calling upsertReservationShifts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/shifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationShifts200ResponseToJSON(requestParameters['getReservationShifts200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationShifts(requestParameters: UpsertReservationShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationShiftsRaw(requestParameters, initOverrides);
    }

}
